import { useRef } from 'react';

import { DEFAULT_PAGE_SIZE } from '../../model';

import { useAssetsServiceBase } from './base/use-assets-service-base';
import { InitialReducerState, defaultReducer, sequenceWindowReducer } from './base/assets-reducer-base';
import { SequenceAssetsWindowManager } from './base/assets-window-manager';

export const useBasicAssetsService = ({ repository, pageSize = DEFAULT_PAGE_SIZE }) => {
  const service = useAssetsServiceBase({
    reducer: defaultReducer,
    reducerInitialArg: InitialReducerState,
    repository,
    pageSize,
  });

  return service;
};

export const useMultiSourceAssetsService = ({ repository, pageSize = DEFAULT_PAGE_SIZE, dataSourceNames }) => {
  const assetWindowManagerRef = useRef(new SequenceAssetsWindowManager(pageSize, dataSourceNames));
  const service = useAssetsServiceBase({
    reducer: sequenceWindowReducer,
    reducerInitialArg: InitialReducerState,
    repository,
    pageSize,
    assetWindowManager: assetWindowManagerRef.current,
  });

  return {
    ...service,
    getAssetCountBySource: () => assetWindowManagerRef.current.getAssetCountBySource(),
  };
};
